<!--
 Golden Partner Holding Website
 Created by Hu Fang.
 Copyright © GPHolding.ch. All rights reserved.
-->

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;/*#2c3e50;*/
  height: 100%;
}

/*cote font*/
@font-face {
  font-family: "AvertaStd-Regular";
  src: url(./assets/font/AvertaStd-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "AvertaStd-Semibold";
  src: url(./assets/font/AvertaStd-Semibold.ttf) format("truetype");
}

@font-face {
  font-family: "AvertaStd-Extrathin";
  src: url(./assets/font/AvertaStd-Extrathin.ttf) format("truetype");
}

/*@font-face {
  font-family: "Zapfino";
  src: url(./assets/font/Zapfino.ttf) format("truetype");
}*/

@font-face {
  font-family: 'Zapfino';
  font-display: auto;
  src:  local('Zapfino'),
        url('./assets/font/Zapfino.ttf') format("truetype");
}

@font-face {
  font-family: "Didot";
  src: url(./assets/font/Didot.ttf) format("truetype");
}

@font-face {
  font-family: "Didot-Bold";
  src: url(./assets/font/Didot-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Avenir-Next-Regular";
  src: url(./assets/font/Avenir-next-regular.otf) format("opentype");
}

@font-face {
  font-family: "Avenir-Next-Medium";
  src: url(./assets/font/Avenir-Next-Medium.otf) format("opentype");
}

@font-face {
  font-family: "Avenir-Next-Bold";
  src: url(./assets/font/Avenir-next-bold.otf) format("opentype");
}

@font-face {
  font-family: "BodoniStd";
  src: url(./assets/font/BodoniStd.otf) format("opentype");
}

/*gp font*/

</style>

<script>
export default {
  name: 'App',
  data() {
    return {
      // isPcShow: !this._isMobile(),
      // isMobShow: this._isMobile()
    }
  },
  mounted: function() {
    // if (this._isMobile()) {
    //     this.$router.replace('/initpage_mob');
    // } else {
    //     this.$router.replace('/initpage_pc');
    // }
  },
  methods: {
    // _isMobile() {

    //   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

    //   let resolutionFlag = document.body.clientWidth;
    //   console.log("resolutionFlag =" + resolutionFlag);
    //   return flag;
    // }
  }
}

</script>
